<template>
  <div class="jumbotron text-center" style="margin: 5px">
    <div v-show="loading">
      <h3 class="display-4">Do not exit this browser</h3>
      <p class="lead">
        We are decisioning your application. This usually takes between one and
        two minutes
      </p>
      <tile loading="isLoading"></tile>
    </div>
    <div v-show="!loading && approved">
      <h3 class="display-4">Congratulations!</h3>
      <p class="lead">
        We have approved your application. Your temporary account number is
        {{ temp_account_number }}.
        <!-- Please download our mobile app "Card Account Manager" on the app store to authorize purchases and view recent transactions.
        <br><br><b>For an auto-filled in app sign up, download the app and then follow <a :href="`retailinformationservices://cam?firstName=${firstName}&lastName=${lastName}&accountNumber=${temp_account_number}`">this link</a>.</b> -->
      </p>
    </div>
    <div v-show="!loading && !approved">
      <p class="lead">
        We could not approve your application at this time. We will notify you
        of your appliation status my mail.
      </p>
    </div>
    <hr />
    <p>
      Having trouble?
      <a>Call us: 1.800.830.7820</a>
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: true,
      approved: false,
      temp_account_number: undefined,
    };
  },
  props: ["firstName", "lastName"],
  methods: {},
  mounted() {
    let self = this;
    this.$socket.$subscribe("DECISION", (payload) => {
      self.loading = false;
      payload = JSON.parse(payload);
      self.approved = payload.approved;
      self.temp_account_number = payload.temp_account_number;
      console.log(payload);
    });
  },
};
</script>
<style></style>
